(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-carousel-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const pxwSlider = document.querySelector('.pxw-testimonial-slider');
  const pxwPrevBtn = document.querySelector('.pxw-slider-arrow.prev');
  const pxwNextBtn = document.querySelector('.pxw-slider-arrow.next');
  const pxwCards = document.querySelectorAll('.pxw-review-card');
  
  let pxwCurrentIndex = 0;
  
  function pxwGetVisibleCards() {
    const width = window.innerWidth;
    if (width > 1200) return 4;
    if (width > 968) return 3;
    if (width > 640) return 2;
    return 1;
  }
  
  function pxwUpdateSlider() {
    const visibleCards = pxwGetVisibleCards();
    const cardWidth = pxwCards[0].offsetWidth;
    const gap = 20;
    const moveAmount = (cardWidth + gap) * visibleCards;
    
    pxwSlider.style.transform = `translateX(-${pxwCurrentIndex * moveAmount}px)`;
    
    // Update button states
    pxwPrevBtn.disabled = pxwCurrentIndex === 0;
    
    const maxIndex = Math.ceil(pxwCards.length / visibleCards) - 1;
    pxwNextBtn.disabled = pxwCurrentIndex >= maxIndex;
  }
  
  pxwNextBtn.addEventListener('click', function() {
    const visibleCards = pxwGetVisibleCards();
    const maxIndex = Math.ceil(pxwCards.length / visibleCards) - 1;
    
    if (pxwCurrentIndex < maxIndex) {
      pxwCurrentIndex++;
      pxwUpdateSlider();
    }
  });
  
  pxwPrevBtn.addEventListener('click', function() {
    if (pxwCurrentIndex > 0) {
      pxwCurrentIndex--;
      pxwUpdateSlider();
    }
  });
  
  // Reset on resize
  let pxwResizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(pxwResizeTimer);
    pxwResizeTimer = setTimeout(function() {
      pxwCurrentIndex = 0;
      pxwUpdateSlider();
    }, 250);
  });
  
  // Initialize
  pxwUpdateSlider();
});

  } catch(e) { console.error(e); }
})();
})();
